var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Math, components, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, prompt, submitUp, undefined, words) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill\"><div class=\"content-md content-fill text-center\"><div class=\"row content-md-ver content-sm-ver content-fit\"><div class=\"col-md-10 col-md-offset-1 col-sm-12 block-v-md\"><h1 class=\"fade-in\">");
// iterate components
;(function(){
  var $$obj = components;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var word = $$obj[i];

var n = 9;
buf.push("<div" + (jade.cls(['word','slide-up',"delay-" + (n - Math.abs(-n + i % (n * 2))) + ""], [null,null,true])) + ">");
if ( word.incorrect)
{
buf.push("<div" + (jade.attr("data-name", word.incorrect, true, false)) + " class=\"droppy\"></div><span class=\"word-text\">" + (null == (jade_interp = word.replaces) ? "" : jade_interp) + "</span>");
}
else
{
buf.push(null == (jade_interp = word.replaces) ? "" : jade_interp);
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var word = $$obj[i];

var n = 9;
buf.push("<div" + (jade.cls(['word','slide-up',"delay-" + (n - Math.abs(-n + i % (n * 2))) + ""], [null,null,true])) + ">");
if ( word.incorrect)
{
buf.push("<div" + (jade.attr("data-name", word.incorrect, true, false)) + " class=\"droppy\"></div><span class=\"word-text\">" + (null == (jade_interp = word.replaces) ? "" : jade_interp) + "</span>");
}
else
{
buf.push(null == (jade_interp = word.replaces) ? "" : jade_interp);
}
buf.push("</div>");
    }

  }
}).call(this);

buf.push("</h1></div><div class=\"col-sm-12 block-v-md\"><div class=\"block-v-lg block-h-md block-dk\">");
// iterate words 
;(function(){
  var $$obj = words ;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var word = $$obj[i];

buf.push("<div" + (jade.attr("data-name", word, true, false)) + (jade.cls(['draggy','btn','btn-sm','btn-solid','slide-up',"delay-" + (i) + ""], [null,null,null,null,null,true])) + ">" + (null == (jade_interp = word) ? "" : jade_interp) + "</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var word = $$obj[i];

buf.push("<div" + (jade.attr("data-name", word, true, false)) + (jade.cls(['draggy','btn','btn-sm','btn-solid','slide-up',"delay-" + (i) + ""], [null,null,null,null,null,true])) + ">" + (null == (jade_interp = word) ? "" : jade_interp) + "</div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"components" in locals_for_with?locals_for_with.components:typeof components!=="undefined"?components:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"words" in locals_for_with?locals_for_with.words:typeof words!=="undefined"?words:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}